import React, { useEffect, useState } from "react";
import Tabs from "../../common/Tabs";
import MeetingInfo from "./MeetingInfo";
import ReminderHistory from "../../common/ReminderHistory";

const MeetingInfoTabs = ({ meeting, setVisible, setVisibleHistory, defaultTab = "info" }) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    setActiveTab(defaultTab);
  }, [defaultTab, meeting?.id]);

  return (
    <div>
      <Tabs
        tabs={[
          { key: "info", label: "Meeting Info" },
          { key: "reminders", label: "Reminder History" },
        ]}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === "info" ? (
        <MeetingInfo meeting={meeting} setVisible={setVisible} setVisibleHistory={setVisibleHistory} />
      ) : (
        <ReminderHistory triggerFor="meetings" triggerId={meeting?.id} />
      )}
    </div>
  );
};

export default MeetingInfoTabs;
